/**
 * WatchlistPill — one "saved in watchlists" pill.
 * @module features/player-detail/components/molecules/WatchlistPill
 */

export { default } from "./WatchlistPillContainer";
export type { WatchlistPillContainerProps } from "./WatchlistPillContainer";
export type { WatchlistPillViewProps } from "./WatchlistPillView";
